import { __decorate } from "tslib";
import { gotToNotificationPage } from "@/util/routeUtil";
import { Component, Vue } from "vue-facing-decorator";
let NotificationFooterList = class NotificationFooterList extends Vue {
  gotToNotificationPage() {
    gotToNotificationPage();
  }
};
NotificationFooterList = __decorate([Component({})], NotificationFooterList);
export default NotificationFooterList;